import {
  getBaseState,
  getEntityAdapterReducers,
  handleFulfilledAction,
  handleMultipleLoadingActions,
} from '@hwm/ui-lib';
import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { EntityReducers } from '@core/store/EntityReducers';
import { thunks } from '@core/store/entity/loggerProgramming/LoggerProgrammingThunks';
import { ILoggerProgram } from '@models/ILoggerProgram';

const entityAdapter = createEntityAdapter<ILoggerProgram>({});

const slice = createSlice({
  name: EntityReducers.loggerPrograms,
  initialState: {
    ...getBaseState(entityAdapter),
  },
  reducers: {
    ...getEntityAdapterReducers(entityAdapter),
  },
  extraReducers: (builder) => {
    handleMultipleLoadingActions([thunks.getProgram, thunks.saveProgram], builder);
    handleFulfilledAction(thunks.getProgram, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
    handleFulfilledAction(thunks.saveProgram, builder, (state, payload) => {
      entityAdapter.upsertOne(state, payload);
    });
  },
});

export const loggerProgrammingReducer = {
  slice,
  entityAdapter,
  thunks,
};
